import React from "react";
import Graph from "../../../../etc/Graph";

const RFund = (parent) => {
    const record = parent.record;
    return (
        <div className="mt-6">
            <div className="d-flex justify-content-between align-items-center mb-px-26">
                <div className="d-flex align-items-center">
                    <h3 className="con-title">연구비 지원(논의)</h3>
                </div>
            </div>
            <div>
                <table className="table table-lightgray">
                    <colgroup>
                        <col width="84%" />
                        <col width="16%" />
                    </colgroup>
                    <thead>
                    <tr>
                        <th scope="col" className="text-left">연구비 지원 기관</th>
                        <th scope="col" className="text-left">과제 번호</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="text-left">Korea Institute of Energy Technology Evaluation and Planning (KETEP)
                            of the Republic of Korea
                        </td>
                        <td className="text-left">20172010000830</td>
                    </tr>
                    <tr>
                        <td className="text-left">Korea Institute of Energy Technology Evaluation and Planning (KETEP) of the Republic of Korea
                        </td>
                        <td className="text-left">20172010000830</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default RFund;
